// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smarttt-page-loader {
    position: fixed;
    inset: 0;
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-color, #0b0f19);
}

.smarttt-page-loader__spinner {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    flex-shrink: 0;
    border: 3px solid;
    border-color: #e5e7eb #e5e7eb transparent transparent;
    box-sizing: border-box;
    animation: smarttt-loader-rotation 1s linear infinite;
}

.smarttt-page-loader__spinner::after,
.smarttt-page-loader__spinner::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    border: 3px solid;
    border-color: transparent transparent var(--brand-primary, #0877BC) var(--brand-primary, #0877BC);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    animation: smarttt-loader-rotation-back 0.5s linear infinite;
    transform-origin: center center;
}

.smarttt-page-loader__spinner::before {
    width: 32px;
    height: 32px;
    border-color: #e5e7eb #e5e7eb transparent transparent;
    animation: smarttt-loader-rotation 1.5s linear infinite;
}

.light-mode .smarttt-page-loader__spinner,
html.light-mode .smarttt-page-loader__spinner {
    border-color: #202226 #202226 transparent transparent;
}

.light-mode .smarttt-page-loader__spinner::before,
html.light-mode .smarttt-page-loader__spinner::before {
    border-color: #202226 #202226 transparent transparent;
}

@keyframes smarttt-loader-rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes smarttt-loader-rotation-back {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(-360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Loading/Loader.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,qDAAqD;IACrD,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,iGAAiG;IACjG,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4DAA4D;IAC5D,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,uDAAuD;AAC3D;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".smarttt-page-loader {\n    position: fixed;\n    inset: 0;\n    z-index: 1200;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--bg-color, #0b0f19);\n}\n\n.smarttt-page-loader__spinner {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: inline-block;\n    position: relative;\n    flex-shrink: 0;\n    border: 3px solid;\n    border-color: #e5e7eb #e5e7eb transparent transparent;\n    box-sizing: border-box;\n    animation: smarttt-loader-rotation 1s linear infinite;\n}\n\n.smarttt-page-loader__spinner::after,\n.smarttt-page-loader__spinner::before {\n    content: \"\";\n    box-sizing: border-box;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    border: 3px solid;\n    border-color: transparent transparent var(--brand-primary, #0877BC) var(--brand-primary, #0877BC);\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    animation: smarttt-loader-rotation-back 0.5s linear infinite;\n    transform-origin: center center;\n}\n\n.smarttt-page-loader__spinner::before {\n    width: 32px;\n    height: 32px;\n    border-color: #e5e7eb #e5e7eb transparent transparent;\n    animation: smarttt-loader-rotation 1.5s linear infinite;\n}\n\n.light-mode .smarttt-page-loader__spinner,\nhtml.light-mode .smarttt-page-loader__spinner {\n    border-color: #202226 #202226 transparent transparent;\n}\n\n.light-mode .smarttt-page-loader__spinner::before,\nhtml.light-mode .smarttt-page-loader__spinner::before {\n    border-color: #202226 #202226 transparent transparent;\n}\n\n@keyframes smarttt-loader-rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes smarttt-loader-rotation-back {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(-360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
